import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5cce996a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "-8px"
  },
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#0044EC"
  }
}, "荣誉"), /*#__PURE__*/_createTextVNode("课程 ")]), /*#__PURE__*/_createElementVNode("div")], -1));

const _hoisted_3 = {
  class: "course-content"
};
const _hoisted_4 = {
  class: "course-data"
};
const _hoisted_5 = {
  class: "course-list"
};
const _hoisted_6 = {
  key: 0,
  class: "classify-box"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "course-card-list"
};
const _hoisted_9 = {
  key: 1,
  class: "no-data"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/86150a57b9044e61b2a810ccbc59cc4a.png"
}, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1));

const _hoisted_12 = [_hoisted_10, _hoisted_11];
const _hoisted_13 = {
  class: "user-content user-box"
};
const _hoisted_14 = ["href"];

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 更多");

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "16",
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202411/ef8515601c4445a596596889eea52307.png",
  alt: ""
}, null, -1));

const _hoisted_17 = [_hoisted_15, _hoisted_16];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_UserCard = _resolveComponent("UserCard");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.typeList && $data.typeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.typeId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_7);
  }), 128))], 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList.slice(0, 3), course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      class: "home-course-card",
      "course-data": course,
      key: course.id,
      "show-label": true,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["course-data", "userInfo", "authType"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("a", {
    href: `/courseList.html?type=1&name=${$props.menu.menu_name}&menuId=${$props.menu.id}`,
    class: "more"
  }, _hoisted_17, 8, _hoisted_14), _createVNode(_component_UserCard, {
    userInfo: $props.userInfo,
    zhsRole: $props.zhsRole
  }, null, 8, ["userInfo", "zhsRole"])])])]);
}